import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import axios from "axios";

Vue.config.productionTip = false;
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    statuses: [],
    activeStatus: null
  },
  mutations: {
    fillStatuses (state, new_statuses) {
      state.statuses = new_statuses;
    },
    changeActiveStatus (state, new_status) {
      state.activeStatus = new_status;
    },
  },
  getters: {
    getStatuses: state => {
      return state.statuses
    },
    getActiveStatus: state => {
      return state.activeStatus
    }
  }
})

const statuses = [];

new Vue({
  el: "#app",
  store,
  mounted: function () {
    var vm = this;
    axios.get("https://5e43f51a3dfe6c001421f280.mockapi.io/api/statuses")
        .then(function (response) {
            vm.$store.commit('fillStatuses', response.data);
        })
        .catch(function (error) {
          console.log(error);
        });
  },
  render: h => h(App)
});
